<div class="container-fluid">
  <div class="row min-vh-100 bg-light">
    <div class="col-12 col-lg-8 mx-auto d-flex align-items-center py-5">
      <div class="w-100">

        <!-- Header -->
        <div class="text-center mb-5">
          <div class="mb-4">
            <i class="fas fa-user-shield text-primary" style="font-size: 4rem;"></i>
          </div>
          <h1 class="display-6 fw-bold text-dark">{{'Permission needed for your child' | translate}}</h1>
          <p class="lead text-muted">{{'Your child wants to create an account. We need your permission first.' | translate}}</p>
        </div>

        <!-- Main Content -->
        <div class="card border-0 shadow-sm">
          <div class="card-body p-4 p-md-5">

            <!-- What we're asking for -->
            <div class="mb-4">
              <h4 class="h5 text-dark mb-3">{{'What are we asking permission for?' | translate}}</h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="d-flex align-items-start">
                    <i class="fas fa-user-graduate text-success me-3 mt-1"></i>
                    <span>{{'Create a profile to find internships and jobs' | translate}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-start">
                    <i class="fas fa-handshake text-success me-3 mt-1"></i>
                    <span>{{'Connect with companies in the region' | translate}}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Important info -->
            <div class="alert alert-info border-0 mb-4">
              <h6 class="alert-heading d-flex align-items-center">
                <i class="fas fa-info-circle me-2"></i>
                {{'Good to know' | translate}}
              </h6>
              <p class="mb-0">{{'If you give permission, your child can use the platform immediately. If you do not give permission within 14 days, the account will be automatically removed. You can also contact us at any time to remove the account.' | translate}}</p>
            </div>

            <!-- Action button - only consent -->
            <div class="text-center">
              <button class="btn btn-success btn-lg px-5 fw-semibold" (click)="giveConsent()" [disabled]="isProcessing">
                <i class="fas fa-check me-2"></i>
                {{'I give permission' | translate}}
              </button>
              <div class="mt-3">
                <small class="text-muted">{{'Your child will be able to use the platform immediately' | translate}}</small>
              </div>
            </div>

            <!-- Don't want to give consent -->
            <div class="mt-4 pt-4 border-top text-center">
              <p class="text-muted mb-2">{{'Don\'t want to give permission?' | translate}}</p>
              <p class="small text-muted mb-3">{{'You don\'t need to do anything. The account will be automatically removed after 14 days if no permission is given.' | translate}}</p>

              <!-- Questions section -->
              <p class="text-muted mb-2">{{'Questions? Need help?' | translate}}</p>
              <a href="mailto:info@meettheyoungsters.nl" class="btn btn-outline-primary">
                <i class="fas fa-envelope me-2"></i>
                {{'Contact us' | translate}}
              </a>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <div class="text-center mt-4">
          <small class="text-muted">
            <i class="fas fa-lock me-1"></i>
            {{'Your privacy and your child\'s safety are very important to us' | translate}}
          </small>
        </div>

      </div>
    </div>
  </div>
</div>
